
import React from 'react';
import EnergyCostAssessment from './EnergyCostAssessment';

const EnergyAssessmentSection = () => {
  return (
    <section className="w-full bg-white py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <EnergyCostAssessment />
        </div>
      </div>
    </section>
  );
};

export default EnergyAssessmentSection;
